import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAppMeta } from "hooks";

import {
  useGetPaymentIntegrationDetailQuery,
  useUpdatePaymentIntegrationMutation,
} from "store/services/paymentIntegrationApi";
import PaymentIntegrationForm from "./PaymentIntegrationComponent/PaymentIntegrationForm";

const PaymentIntegrationEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Payment Integrations", path: "/app/crm/paymentIntegration/list" },
    { title: "Edit Payment Integration" },
  ];

  // RTK Query
  const {
    data: paymentIntegrationDetail,
    isLoading: loadingPaymentIntegrationDetail,
    error,
  } = useGetPaymentIntegrationDetailQuery(id);

  const [updatePaymentIntegration, { isLoading: updatingPaymentIntegration }] =
    useUpdatePaymentIntegrationMutation();

  // methods
  const handleUpdatePaymentIntegration = async (data) => {
    try {
      await updatePaymentIntegration({ ...data, _id: id }).unwrap();
      toast.success("Payment Integration successfully updated!");
      navigate(breadcrumbs[0]?.path);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Payment Integration!");
    }
  };

  useAppMeta("Edit Payment Integration");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingPaymentIntegrationDetail || updatingPaymentIntegration}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <PaymentIntegrationForm
          isBusy={loadingPaymentIntegrationDetail || updatingPaymentIntegration}
          paymentIntegrationDetail={paymentIntegrationDetail}
          onSubmit={handleUpdatePaymentIntegration}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default PaymentIntegrationEditScreen;